<template>
    <v-container>
        <v-row class="mt-3" align="center">
            <v-col cols="12">
                <div class="headline-light secondary-color">
                    Perfil {{ currentEntityLabel }}
                </div>
                <div class="display-heavy primary-color">
                    Sucursales Asociadas
                </div>
            </v-col>
            <v-col cols="12" align="right">
                <v-btn class="normal-btn mb-1" color="primary" outlined large @click="addBranchOffice">
                    Agregar Sucursal
                </v-btn>
            </v-col>
            <v-col cols="12">
                <kimsa-data-table
                    :headers="headers"
                    :items="branchOffices"
                    :loading="loadingBranchOffices"
                    @action="onAction"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import KimsaDataTable from "@/components/common/KimsaDataTable";
import httpService from "@/services/httpService";
export default {
    name: "BranchOffices",
    components: {KimsaDataTable},
    data() {
        return {
            headers: [
                {text: 'Nombre', value: 'name'},
                {text: 'Dirección', value: 'address'},
                {text: 'Región', value: 'region'},
                {text: 'Comuna', value: 'city'},
                {text: 'Exámenes posibles', value: 'exams'},
                {text: 'Sitio Web', value: 'web', type: 'link'},
                {text: 'Teléfono', value: 'phone', type: 'phone'},
                {text: 'Horario', value: 'schedule'},
                {text: 'Email', value: 'email'},
                {text: '', value: 'actions'},
            ],
            branchOffices: [],
            loadingBranchOffices: false,
        }
    },
    async mounted() {
        const vm = this
        if(vm.currentEntityId) await vm.loadBranchOffices()
    },
    methods: {
        async loadBranchOffices() {
            const vm = this
            vm.loadingBranchOffices = true

            let response = await httpService.get(`laboratory/${vm.currentEntityId}/branch-offices`)
            vm.branchOffices = response.data.branch_offices.map(branchOffice => ({
                ...branchOffice,
                exams: branchOffice.exams.length || 0
            }))

            vm.loadingBranchOffices = false
        },
        addBranchOffice() {
            const vm = this
            vm.$router.push({name: 'admin.branchOffices.create'})
        },
        onAction(branchOfficeId) {
            const vm = this
            vm.$router.push({name: 'admin.branchOffices.edit', params: {branchOfficeId: branchOfficeId}})
        }
    },
    watch: {
        currentEntityId(val) {
            if (val) this.loadBranchOffices()
        }
    }
}
</script>

<style scoped>

</style>